<template>
    <div class="alert" v-prevent-overscroll>
        <div class="alert-area">
            <div class="notice-wrapper" :style="wrapperStyle">
                
            </div>
           
            <div class="close-area">
                <div class="close-border"></div>
                <img class="close-icon" :src="closeIconUrl" @click.stop="closeViewNotice" />
            </div>
        </div>
    </div>
  
</template>

<script>

let closeIcon = require('@/assets/imgs/close.png')

export default {
    
    name: 'viewNotice',

    props: {

        info: {
            type: Object,
        },
        
    },

    data() {
        return {

            closeIconUrl: closeIcon,

            wrapperStyle: {}, // 包裹框样式

            
        }
    },

    mounted() {

        this.init()

    },

    methods: {

        init() {

            this.initStyle(this.info)

        },

        initStyle(val) {

            let { baseConfig, } = val

            let transform = (config, imgKey) => {

                let options = {}

                if (config.position1 && config.position1.type) {
                    options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
                }

                if (config.position2 && config.position2.type) {
                    options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
                }

                if (config.width) {
                    options.width = `${config.width}px`
                }

                if (config.height) {
                    options.height = `${config.height}px`
                }

                if (imgKey) {
                    if (config[imgKey] && config[imgKey].url) {
                        let background = {
                            backgroundImage: `url(${config[imgKey].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        }
                        options= Object.assign(options, background)
                    }
                }

                return options
            }

            this.wrapperStyle = baseConfig && transform(baseConfig, 'img') || {}


        },

        closeViewNotice() { // 关闭查看虚拟奖品
            this.$emit('emitEvent', {
                type: 'closeViewNotice',
                data: null,
                options: null
            })

        },

    },

}

</script>

<style lang="scss" scoped>

.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.notice-wrapper {
    position: relative;
}

.close-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.close-border {
    border-left: 4px dashed #fff;
    height: 100px;
}

.close-icon {
    width: 68px;
    height: 68px;
}

</style>